/* eslint-disable @typescript-eslint/naming-convention */

import { parse } from 'date-fns';

import { CustomDateRangeFilterId } from 'constants/filters/date-range-filter';
import { type ReportDistribution } from 'constants/reports/distribution';
import { type IReportsViewUpdateFiltersPayload } from 'interfaces/reports';

export const REPORT_URL_BY_NAME_CONFIG: Record<string, string> = {
  total_chats: '/reports/total-chats',
  chat_ratings: '/reports/chat-ratings',
  goals: '/reports/goals',
  dashboard: '/reports/dashboard',
  agents_performance: '/reports/agent-performance',
  most_frequent_questions: '/reports/top-customer-questions',
  tag_trends: '/reports/top-customer-questions',
};

const DATE_FORMAT_EXCLUDING_TIMEZONE = "yyyy-MM-dd'T'HH:mm:ss'Z'";

function parseAsLocalDate(date: string): Date {
  return parse(date, DATE_FORMAT_EXCLUDING_TIMEZONE, new Date());
}

export function mapResponseToViewFilters(filters: Record<string, unknown>): IReportsViewUpdateFiltersPayload {
  const viewFilters: IReportsViewUpdateFiltersPayload = {};

  if (Array.isArray(filters.agents)) {
    {
      viewFilters.agent = {
        agents: filters.agents,
      };
    }
  }

  if (filters.distribution) {
    viewFilters.distribution = filters.distribution as ReportDistribution;
  }

  if (filters.date_from && filters.date_to) {
    viewFilters.dateRange = {
      from: new Date(filters.date_from as string),
      to: new Date(filters.date_to as string),
      id: CustomDateRangeFilterId.CustomPeriod,
    };
  }

  if (filters.from && filters.to) {
    viewFilters.dateRange = {
      from: parseAsLocalDate(filters.from as string),
      to: parseAsLocalDate(filters.to as string),
      id: CustomDateRangeFilterId.CustomPeriod,
    };
  }

  return viewFilters;
}
